import React, { useEffect, useRef, useState } from "react";
import style from "./plotDetails.module.css";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import cloudimg from '../../../assets/images/svgs/cloud-upload-svgrepo-com.svg';
import { BASE_URL } from "../../../constants/Constants";
import { useLocation, useNavigate } from "react-router-dom";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import { useUser } from "../../../contexts/UserContext";
import { _axios } from "../../../utils/axios";

const PlotDetails = () => {
    const { state } = useLocation();
    const documentData = state?.documentData;
    const navigate = useNavigate();
    const shapeRef = useRef<any>(null);
    const [file, setFile] = useState<any>();
    const [status, setStatus] = useState<number>(documentData ? documentData.status : 1); // Initialize status with documentData status if available
    const [imageUrl, setImageUrl] = useState<string>(documentData?.plot_shape ?? "");

    const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const selectedFile = e.target.files[0];
            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];

            if (allowedTypes.includes(selectedFile.type)) {
                setFile(selectedFile);
                setImageUrl(URL.createObjectURL(selectedFile));
            } else {
                ErrorToast('Only JPG, PNG, and JPEG files are allowed');
                e.target.value = ''; // Reset the input
            }
        }
    };

    const setdata = (e: React.ChangeEvent<HTMLInputElement>) => {
        setStatus(e.target.checked ? 1 : 0);
    };

    const createPlotShape = async () => {
        const formData = new FormData();
        if (file) {
            formData.append('plot_shape', file);
        }
        formData.append('status', String(status));

        try {
            const response = await _axios.post(`${BASE_URL}/api/plotshape/create`, formData);
            if (response.data.success === 0) {
                ErrorToast(response.data.message);
            } else {
                SuccessToast('Plot Shape Record Created');
                navigate('/plot-shape');
            }
        } catch (error: any) {
            ErrorToast(error.response?.data?.message || 'An error occurred');
        }
    };

    const updatePlotShape = async () => {
        const formData = new FormData();
        if (file) {
            formData.append('plot_shape', file);
        }
        formData.append('status', String(status));
        formData.append('id', documentData.id);

        try {
            const response = await _axios.patch(`${BASE_URL}/api/plotshape/upload`, formData);
            if (response.data.success === 0) {
                ErrorToast(response.data.message);
            } else {
                SuccessToast('Plot Shape Updated');
                navigate('/plot-shape');
            }
        } catch (error: any) {
            ErrorToast(error.response?.data?.message || 'An error occurred');
        }
    };

    const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (documentData) {
            updatePlotShape();
        } else {
            createPlotShape();
        }
    };

    return (
        <div className="px-5 py-5">
            <div className={style.divBodyHeading}>
                <div className={style.headerContent}>
                    <p className={style.bodyTitle}>{documentData ? 'Edit' : 'Create'} Plot Shape</p>
                </div>
                <form onSubmit={onSubmit}>
                    <BoxComponent>
                        <div className={style.card}>
                            <p className={style.browseLabel}>Select Plot Shape</p>
                            <div className={style.uploadContainerDocument}>
                                <label className={style.uploadLable} onClick={() => shapeRef?.current?.click()}>Browse</label>
                                <small className={style.smallFont}>
                                    {imageUrl ? (
                                        <img src={imageUrl} alt="Uploaded Image" />
                                    ) : (
                                        <img src={cloudimg} alt="Cloud Icon" />
                                    )}
                                </small>
                                {/* <input
                                id="plot_shape"
                                type="file"
                                name="plot_shape"
                                accept="image/jpeg, image/png, image/jpg"
                                ref={shapeRef}
                                style={{ display: "none" }}
                                onChange={handleFile}
                            /> */}
                                <input
                                    id="plot_shape"
                                    type="file"
                                    name="plot_shape"
                                    accept="image/jpeg, image/png, image/jpg"
                                    ref={shapeRef}
                                    style={{ display: "none" }}
                                    onChange={handleFile}
                                />
                            </div>
                            <div className={style.rowOne}>
                                <label className={style.footerActive}>Activate</label>
                                <div className={style.footerAct}>
                                    <label className={style.toggleBtn}>
                                        <input
                                            type="checkbox"
                                            checked={status === 1}
                                            onChange={setdata}
                                            className={style.inputCheckbox}
                                        />
                                        <span className={style.slider}></span>
                                    </label>
                                </div>
                            </div>
                            <div className={style.rightContent}>
                                <button className="bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300" type="submit">Publish</button>
                                <button className="bg-black ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300" onClick={() => navigate("/plot-shape")}>Back</button>
                            </div>
                        </div>
                    </BoxComponent>
                </form>
            </div>
        </div>
    );
};

export default PlotDetails;